import React from "react";

const Search = props => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    <g fill="none" fillRule="evenodd" stroke="currentColor">
      <path
        d="M16.5 16.5l6.615 6.615"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray={33.94}
      />
      <circle strokeLinecap="square" cx={9.846} cy={9.846} r={8.846} />
    </g>
  </svg>
);

export default Search;



// WEBPACK FOOTER //
// ./src/theme/icons/Search.js